import { baseApi } from './baseApi';

const CourseApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCourses: builder.query({
      query: (queryParameters) => ({
        url: '/courses/enroll/all',
        method: 'GET',
        params: queryParameters,
      }),
      providesTags: ['courses'],
    }),
    getCourse: builder.query({
      query: (courseId) => ({
        url: `/courses/${courseId}`,
        method: 'GET',
      }),
      providesTags: ['courses'],
    }),
    createCourse: builder.mutation({
      query: (courseData) => ({
        url: '/courses/create',
        method: 'POST',
        data: courseData,
      }),
      invalidatesTags: ['courses'],
    }),
    updateCourse: builder.mutation({
      query: ({ courseId, updatedCourseData }) => ({
        url: `/courses/update/${courseId}`,
        method: 'PATCH',
        data: updatedCourseData,
      }),
      invalidatesTags: ['courses'],
    }),
    deleteCourse: builder.mutation({
      query: (courseId) => ({
        url: `/courses/delete/${courseId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['courses'],
    }),
  }),
});

export const {
  useGetCoursesQuery,
  useGetCourseQuery,
  useCreateCourseMutation,
  useUpdateCourseMutation,
  useDeleteCourseMutation,
} = CourseApi;
